import {OggettoConfig} from "../../../app/shared/_services/dynamic-crud.service";
import { UserIs} from "./SanPellegrino";
import {BottoneAggiuntivo, CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {ToastrService} from "ngx-toastr";

export function AssegnazioneCoupon(): OggettoConfig {
  function getType(type: 'sellin'| 'sellout'| 'omaggio'){
    switch (type) {
      case 'sellin':
        return 'SI';
      case 'sellout':
        return 'SO';
      case 'omaggio':
        return 'OM';
    }
  }
  return {
    Id: "assegna",
    fullListRoute: "/prodotti/coupon/coupon",
    listClass:'tr-td-border',
    noWrap:true,
    listStyle:null,
    ListDefaultFilterFunc:(component)=> {
      return {
        dm: UserIs("DM", component.authSvc.currentUserValue) ? component.authSvc.currentUserValue?.id : null
      }
    },
    DynamicHeaders: (component) => {
      var ColonneProd = component.ListResponse.prodotti.map(x => {
        return {
          nome: x.prodotto,
          modificabile:true,
          class: 'row-max-content',
          type:"ArrayCampiAggiuntivi",
          oggetti: [x.prodotto.toLowerCase().replaceAll(" ", "")+"Field"],
          printable: false,
        }
      })
      return [{
        ...CampoAggiuntivo.TextField("Manager", "manager", "col-lg-12"),
        modificabile: false,
        printable: false
      }, ...ColonneProd]
    },
    ListMap(response) {
      var out = response['referenti'].map(manager => {
        var row = {manager: manager.fullName, id_manager: manager.id,}
        response['prodotti'].forEach(prodotto => {
          const prodKey = prodotto.prodotto.toLowerCase().replaceAll(" ", "");
          row[prodKey] = manager.coupons.find(prod => prod.idProdotto == prodotto.id);

          function getAssegnaCrudSettings(type: 'sellin'| 'sellout'| 'omaggio'):OggettoConfig{
            return {
              Id:"Assegna",
              RestRoute:"/prodotti/coupon/assegna",
              campi:[
                CampoAggiuntivo.InputField("Quantità da assegnare", "assegnare", "number")
              ],
              customSave:(x, api, end, bup, toastService: ToastrService)=>{
                var tosend: {persona: number, prodotto:number, tipo: "SI" | "SO" | "OM", quantita: number } = {
                  persona: manager.id,
                  prodotto: prodotto.id,
                  tipo: getType(type),
                  quantita: x.assegnare
                }
                console.log("Data:", x);
                console.log("tosend: ", tosend);
                if(!x.assegnare || x.assegnare < 1){
                  toastService.warning("Devi specificare una quantità da assegnare.")
                  return;
                }
                if(parseInt(x.assegnare?.toString() ?? '0')>row[prodKey][`${type}Disponibli`]) {
                  toastService.warning("La quantità da assegnare non può essere maggiore di quella disponibile.")
                  return;
                }
                api.ClassicPost("/prodotti/coupon/assegna", tosend).subscribe(()=>{
                  if(end)
                    end(x);
                })

              }
            }
          }

          function getAssegnaButton(type: 'sellin'| 'sellout'| 'omaggio' ):BottoneAggiuntivo {
            return {
              nome:"Assegna",
              label:"Assegna",
              type:'edit',
              edit:true,
              icon:'fas fa-plus',
              ExternalSave: false,
              CrudSettings: getAssegnaCrudSettings(type),
              color:'blue',
              hideif:{func:(x)=>row[prodKey][`${type}Disponibli`]}
            }
          }
          function getRevocaButton(type: 'sellin'| 'sellout'| 'omaggio' ):BottoneAggiuntivo {
            return {
              nome:"Revoca",
              label:"Revoca",
              type:'edit',
              edit:true,
              icon:'fa-solid fa-minus',
              ExternalSave: false,
              CrudSettings: getRevocaCrudSettings(type),
              color:'blue',
              hideif:{func:(x)=>row[prodKey][`${type}NonAssegnati`]}
            }
          }
          function getRevocaCrudSettings(type: 'sellin'| 'sellout'| 'omaggio'):OggettoConfig{
            return {
              Id:"revoca",
              RestRoute:"/prodotti/coupon/assegna",
              campi:[
                CampoAggiuntivo.InputField("Quantità da revocare", "assegnare", "number")
              ],
              customSave:(x, api, end, bup, toastService: ToastrService)=>{
                var tosend: {persona: number, prodotto:number, tipo: "SI" | "SO" | "OM", quantita: number } = {
                  persona: manager.id,
                  prodotto: prodotto.id,
                  tipo: getType(type),
                  quantita: x.assegnare
                }
                if(!x.assegnare || x.assegnare < 1){
                  toastService.warning("Devi specificare una quantità da revocare.")
                  return;
                }
                if(parseInt(x.assegnare?.toString() ?? '0')>row[prodKey][`${type}NonAssegnati`]) {
                  toastService.warning("La quantità da revocare non può essere maggiore di quella disponibile.")
                  return;
                }
                api.ClassicPost("/prodotti/coupon/rilascia", tosend).subscribe(()=>{
                  if(end)
                    end(x);
                })

              }
            }
          }


          function getCouponRow(type: 'sellin'| 'sellout'| 'omaggio', Title:string):CampoAggiuntivo[]{
            var Row:CampoAggiuntivo[] = []
            if(row[prodKey][`${type}Disponibli`] ||row[prodKey][`${type}Assegnati`]){
              Row = [
                {nome:Title, oggetti:[''], class:"col-lg-12", modificabile:false, azioni:[getAssegnaButton(type), getRevocaButton(type)]},
                CampoAggiuntivo.InputField("Disponibili",`${prodKey}.${type}Disponibli`,"numeric","col-lg-4", {modificabile:false}),
                CampoAggiuntivo.InputField("Assegnati",`${prodKey}.${type}Assegnati`,"numeric","col-lg-4", {modificabile:false}),
                CampoAggiuntivo.InputField("Non Utilizzati",`${prodKey}.${type}NonAssegnati`,"numeric", "col-lg-4", {modificabile:false}),
              ]
            }
            return Row;
          }



          row[prodKey + 'Field'] = [
            ...getCouponRow('sellin', 'SELL-IN'),
            ...getCouponRow('sellout', 'SELL-OUT'),
            ...getCouponRow('omaggio', 'OMAGGIO'),
          ]
        })
        return row;
      })
      console.log("List: ", out);
      return out
    },
    MenuItems: [
      {
        path: "/sanpellegrino/shared/dynamiclist/assegna",
        title: "Assegnazione",
        icon: "fa-solid fa-people-arrows",
        class: "",
        capacita: [],
        ruoliOperativi:["DM", "K"]
      },
    ]
  };
}
